import { RotateCcw, X } from "lucide-react";

export default function ActiveFilters({ chips, onReset }) {
  if (!chips.length) return null;
  return (
    <div className="active-filters" data-testid="active-filters">
      <span className="mono-label">AKTIVE FILTER</span>
      <div className="active-filter-chips">
        {chips.map((chip) => <button type="button" key={chip.key} className="active-filter-chip" onClick={chip.onRemove} aria-label={`Filter ${chip.label} entfernen`} data-testid={`active-filter-${chip.key}`}>{chip.label} <X size={13} strokeWidth={2.2} /></button>)}
        <button type="button" className="text-action active-filters-reset" onClick={onReset} data-testid="active-filters-reset-button"><RotateCcw size={13} /> Alle Filter zurücksetzen</button>
      </div>
    </div>
  );
}
